module.exports = __webpack_public_path__ + "static/img/blog_good_5.c1d24fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/blog_good_5.png
// module id = MxeV
// module chunks = 8